import { render, staticRenderFns } from "./iconAdd.vue?vue&type=template&id=8bd17abc&scoped=true&"
import script from "./iconAdd.vue?vue&type=script&lang=js&"
export * from "./iconAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd17abc",
  null
  
)

export default component.exports